import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import GET_BANNER_COLLAGE from '../queries/getBannerCollage';
import { BannerCollageResponse } from '../types';

const useBannerCollage = (collage: string): BannerCollageResponse => {
  const { data, loading, error } = useEdgeQuery(GET_BANNER_COLLAGE, {
    variables: {
      id: collage,
    },
    skip: !collage,
  });

  return {
    bannerCollage: data?.bannerCollage,
    loading,
    error,
  };
};

export default useBannerCollage;
